import { useState } from "react";
import { resolveImg } from "@/App";

/**
 * Generates a small inline SVG data URL with the person's initials
 * over the tertulia palette (alabastro + oro + azul).
 */
function initialsFor(name = "") {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "··";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function placeholderSvg(name, seed = 0) {
  const ini = initialsFor(name);
  // Soft alabastro background + gold gradient tone varied by seed for visual variety
  const hue = (200 + seed * 23) % 360;
  const svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 400" preserveAspectRatio="xMidYMid slice">
  <defs>
    <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#f5efe6"/>
      <stop offset="100%" stop-color="hsl(${hue},25%,88%)"/>
    </linearGradient>
  </defs>
  <rect width="300" height="400" fill="url(#bg)"/>
  <text x="50%" y="52%" text-anchor="middle" dominant-baseline="middle"
        font-family="Cormorant Garamond, Georgia, serif" font-weight="300"
        font-size="120" fill="#c9a74a" letter-spacing="2">${ini}</text>
  <text x="50%" y="85%" text-anchor="middle"
        font-family="Inter, sans-serif" font-size="11" letter-spacing="4"
        fill="#8d8070" text-transform="uppercase">IN DUBIO</text>
</svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

/**
 * <SafeImg> — standard <img> that silently falls back to an initials
 * placeholder SVG when the source is missing or fails to load.
 */
export default function SafeImg({ src, alt = "", name, className, style, loading = "lazy", ...rest }) {
  const [broken, setBroken] = useState(false);
  const resolved = src ? resolveImg(src) : "";
  const useFallback = broken || !resolved;
  const finalSrc = useFallback ? placeholderSvg(name || alt) : resolved;
  return (
    <img
      src={finalSrc}
      alt={alt}
      loading={loading}
      className={className}
      style={style}
      onError={() => setBroken(true)}
      {...rest}
    />
  );
}
